(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ctc-welcome-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-ctc-welcome-popup]';

    const storageGet = (key) => {
      try {
        return JSON.parse(localStorage.getItem(key));
      } catch (error) {
        return null;
      }
    };

    const storageSet = (key, value) => {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch (error) {
        return;
      }
    };

    const initPopup = (popup) => {
      if (!popup || popup.dataset.initialized === 'true') return;
      popup.dataset.initialized = 'true';

      const dialog = popup.querySelector('.ctc-welcome-popup__dialog');
      const dismissers = popup.querySelectorAll('[data-ctc-popup-dismiss]');
      const submitButton = popup.querySelector('[data-ctc-popup-submit]');
      const copyButton = popup.querySelector('[data-ctc-copy-code]');
      const success = popup.querySelector('[data-ctc-popup-success]');
      const error = popup.querySelector('[data-ctc-welcome-error]');
      const key = 'ctc-welcome-popup-v1';
      const delay = Math.max(Number(popup.dataset.delaySeconds) || 35, 10) * 1000;
      const cooldown = Math.max(Number(popup.dataset.cooldownDays) || 14, 1) * 86400000;
      const exitIntentEnabled = popup.dataset.exitIntent === 'true';
      const designMode = popup.dataset.designMode === 'true';
      const earliestInteraction = Date.now() + 8000;
      let timer;
      let previousFocus;

      const status = storageGet(key);
      const suppressed = status && (status.state === 'subscribed' || Number(status.until) > Date.now());

      const focusable = () => Array.from(dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled])'));

      const open = () => {
        clearTimeout(timer);
        window.removeEventListener('scroll', onScroll);
        document.removeEventListener('mouseout', onMouseOut);
        previousFocus = document.activeElement;
        popup.hidden = false;
        document.body.classList.add('ctc-welcome-popup-open');
        requestAnimationFrame(() => {
          popup.classList.add('is-open');
          const first = focusable()[0];
          if (first) first.focus();
          else dialog.focus();
        });
      };

      const close = () => {
        popup.classList.remove('is-open');
        document.body.classList.remove('ctc-welcome-popup-open');
        if (!success) {
          storageSet(key, { state: 'dismissed', until: Date.now() + cooldown });
        }
        window.setTimeout(() => {
          popup.hidden = true;
          if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
        }, 220);
      };

      function onScroll() {
        if (Date.now() < earliestInteraction) return;
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable > 0 && window.scrollY / scrollable >= 0.4) open();
      }

      function onMouseOut(event) {
        if (!exitIntentEnabled || Date.now() < earliestInteraction || window.innerWidth <= 760) return;
        if (!event.relatedTarget && event.clientY <= 8) open();
      }

      dismissers.forEach((button) => button.addEventListener('click', close));

      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          return;
        }

        if (event.key !== 'Tab') return;
        const items = focusable();
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      if (submitButton) {
        submitButton.closest('form').addEventListener('submit', () => {
          submitButton.disabled = true;
          submitButton.textContent = submitButton.dataset.loadingText;
        });
      }

      if (copyButton) {
        copyButton.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(copyButton.dataset.code);
            const label = copyButton.querySelector('[data-ctc-copy-label]');
            if (label) label.textContent = copyButton.dataset.copiedText;
          } catch (error) {
            return;
          }
        });
      }

      if (success) {
        storageSet(key, { state: 'subscribed' });
        open();
        return;
      }

      if (error || designMode) {
        open();
        return;
      }

      if (suppressed) return;

      timer = window.setTimeout(open, delay);
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('mouseout', onMouseOut);
    };

    const initAll = (root = document) => {
      if (root.matches && root.matches(selector)) initPopup(root);
      root.querySelectorAll(selector).forEach(initPopup);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
